import React from "react";
import styled from "styled-components";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import CopyIcon from "@material-ui/icons/FileCopy";
import ShareIcon from "@material-ui/icons/Share";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import Item from "../../inspect/components/tracker/item";
import { DarkTooltip } from "../../inspect/components/tooltip";
import Icon from "@material-ui/core/Icon";

const CustomRow = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 1440px;
  margin-bottom: 10px;
  h4 {
    font-size: 1.125rem;
  }
  > div {
    padding: 10px 16px;
  }
  > div:nth-child(1) {
    flex-basis: 350px;
  }
  > div:nth-child(2) {
    flex: 2;
  }
`;

const Macros = styled.div`
  display: flex;
  span {
    color: #697f97;
    font-size: 0.9rem;
    font-weight: bold;
    padding: 0 10px 0 0;
  }
`;

const Notes = styled.div`
  p {
    display: flex;
    align-items: flex-start;
    font-size: 0.9rem;
    max-width: 600px;
  }

  span {
    font-size: 1rem;
    margin: 1px 6px;
    color: #070c29;
  }
`;

export const DayListItem = ({ day, edit, copy, share, remove }) => {
  const wrapTooltip = (children) => {
    return (
      <DarkTooltip title={renderMeals(day.meals)} delay={100}>
        <>{children}</>
      </DarkTooltip>
    );
  };

  const renderMeals = (meals) => {
    const category = ["breakfast", "lunch", "dinner", "snacks", "other"];
    const mealList = category.map((c) => {
      let categoryString = `${c.charAt(0).toUpperCase() + c.slice(1)}`;
      let mealString = "";
      const meal = meals.find((meal) => meal.category === c);
      if (meal) {
        meal.foods.forEach((item) => {
          mealString += `${item.name}, `;
        });

        mealString = mealString.slice(0, -2);
      } else {
        return null
      }
      return (
        <p style={{ display: 'flex', alignItems: 'flex-start', marginBottom: "12px" }}>
          <span style={{fontWeight: 'bold', textDecoration: 'underline', marginRight: '2px'}}>{categoryString}</span>
          <span style={{marginRight: '4px'}}>:</span>
          {mealString}
        </p>
      );
    });

    return mealList;
  };

  const renderCategories = (meals) => {
    const category = ["breakfast", "lunch", "dinner", "snacks", "other"];
    let mealList = "";

    category.forEach((c) => {
      const meal = meals.find((meal) => meal.category === c);
      if (meal) {
        mealList += `${c.charAt(0).toUpperCase() + c.slice(1)}, `;
      }
    });

    mealList = mealList.slice(0, -2);
    return mealList;
  };

  const renderMacros = (meals) => {
    let protein = 0;
    let carbs = 0;
    let fat = 0;
    let calories = 0;
    let fiber = 0;

    meals.forEach((data) => {
      data.foods.forEach((entry) => {
        const item = new Item(entry);
        if (item.itemType === "recipe") {
          protein += item.getRecipeProtein();
          carbs += item.getRecipeCarbs();
          fat += item.getRecipeFat();
          fiber += item.getRecipeFiber();
        } else {
          protein += item.getProtein();
          carbs += item.getCarbs();
          fat += item.getFat();
          fiber += item.getFiber();
        }
      });
    });

    calories = (4 * (carbs + protein) + 9 * fat).toFixed(0);
    protein = protein.toFixed(1);
    carbs = carbs.toFixed(1);
    fat = fat.toFixed(1);
    fiber = fiber.toFixed(1);

    return (
      <Macros>
        {hasFood(meals) ? (
          <>
            <span>{protein} P</span>
            <span>{carbs} C</span>
            <span>{fat} F</span>
            <span>{calories} Cal</span>
            <span>{fiber} Fiber</span>
          </>
        ) : (
          <span>No foods have been added</span>
        )}
      </Macros>
    );
  };

  const hasFood = (meals) => {
    let food = false;
    meals.forEach((data) => {
      if (data.foods.length !== 0) {
        food = true;
      }
    });
    return food;
  };

  return (
    <CustomRow>
      <div>
        <h4 style={{ display: "flex", alignItems: "center" }}>
          {day.name}
          {hasFood(day.meals) &&
            wrapTooltip(
              <Icon
                style={{ display: "flex", marginLeft: "6px", color: "#070c29" }}
              >
                search
              </Icon>
            )}
        </h4>
        {hasFood(day.meals) && (
          <div style={{ display: "inline-block" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ fontSize: "1rem" }}>{renderCategories(day.meals)}</p>
            </div>
          </div>
        )}
        {renderMacros(day.meals)}
      </div>
      {day.notes && (
        <Notes>
          <p>
            <Icon>description</Icon>
            {day.notes}
          </p>
        </Notes>
      )}
      {edit && share && remove && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <IconButton color="inherit" onClick={() => edit(day.id)} title="Edit">
            <EditIcon />
          </IconButton>
          <IconButton
            color="inherit"
            onClick={() => copy(day.id)}
            title="Copy"
          >
            <CopyIcon />
          </IconButton>
          <IconButton
            color="inherit"
            onClick={() => share(day.id)}
            title="Share"
          >
            <ShareIcon />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => remove(day)}
            title="Delete"
          >
            <DeleteIcon />
          </IconButton>
        </div>
      )}
    </CustomRow>
  );
};
